import { render, staticRenderFns } from "./movetosilo.vue?vue&type=template&id=a583b2ba&scoped=true&"
import script from "./movetosilo.vue?vue&type=script&lang=js&"
export * from "./movetosilo.vue?vue&type=script&lang=js&"
import style0 from "./movetosilo.vue?vue&type=style&index=0&id=a583b2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a583b2ba",
  null
  
)

export default component.exports